module.exports = __webpack_public_path__ + "static/media/LogoutLight.30ca6278.svg";